import React from "react";

export default class RedirectInvalidRequestScreen extends React.Component {
  render() {
    return <div>Invalid request</div>;
  }
}
